import { render, staticRenderFns } from "./RundownCommandEditor.vue?vue&type=template&id=4dd6179c&"
import script from "./RundownCommandEditor.vue?vue&type=script&lang=js&"
export * from "./RundownCommandEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports